var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-depth */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import { convertStringToBase64, convertBase64ToString, convertHexToBase64 } from './utils';
import SecurityCrypto from './crypto';
import { processRequestConfig, processResponseConfig } from './utils/hooks';
import { createRequest } from './request';
var publicCacheKey = 's_sdk_pub_key';
var privateCacheKey = 's_sdk_pri_key';
var certificateCacheKey = 's_sdk_cert_key';
var signCacheKey = 's_sdk_sign_key';
var signDataCacheKey = 's_sdk_sign_data_key';
var single_public_key, single_private_key, single_certification;
var requestCertPEMPromise = null;
var CryptoSDK = /** @class */ (function () {
    function CryptoSDK(params) {
        var _this = this;
        this._checkCryptKeys = function () { return __awaiter(_this, void 0, void 0, function () {
            var pub_data, pri_data, cert_data, sign_data, _a, ec_privateKey, ec_publicKey, result;
            var _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        pub_data = (_b = this._cacheSDK) === null || _b === void 0 ? void 0 : _b.get(publicCacheKey);
                        pri_data = (_c = this._cacheSDK) === null || _c === void 0 ? void 0 : _c.get(privateCacheKey);
                        cert_data = (_d = this._cacheSDK) === null || _d === void 0 ? void 0 : _d.get(certificateCacheKey);
                        sign_data = (_e = this._cacheSDK) === null || _e === void 0 ? void 0 : _e.get("".concat(signDataCacheKey, "/").concat(this._scene));
                        if (pub_data && pri_data && cert_data) {
                            this._private_key = pri_data;
                            this._public_key = pub_data;
                            this._certificate = cert_data;
                            // this._ts_sign = ts_sign;
                            this._sign_data = sign_data;
                            this.cryptoSDK = new SecurityCrypto({ type: 'ECDSA', privateKey: pri_data, publicKey: pub_data });
                            return [2 /*return*/, true];
                        }
                        if (this._certType === 'header') {
                            _a = this._getCertificatePem(), ec_privateKey = _a.ec_privateKey, ec_publicKey = _a.ec_publicKey;
                            this._public_key = ec_publicKey;
                            this._private_key = ec_privateKey;
                            (_f = this._cacheSDK) === null || _f === void 0 ? void 0 : _f.set(publicCacheKey, this._public_key);
                            (_g = this._cacheSDK) === null || _g === void 0 ? void 0 : _g.set(privateCacheKey, this._private_key);
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.refresh(true)];
                    case 1:
                        result = _h.sent();
                        return [2 /*return*/, result];
                }
            });
        }); };
        /**
         * 获取当前证书签名 如果certType 传的是request 使用这个方法获取证书 如果没设置certType 那 use {@link getCertificateV2}
         * @returns string | false false表示生成证书失败 string表示成功 （可查看localStorage 或者其他存储 是否包含公私钥
         */
        this.getCertificate = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkCryptStatus];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res ? convertStringToBase64(this._certificate || '') : false];
                }
            });
        }); };
        /**
         * 获取当前证书 非劫持的情况下 如果certType 为 header时 需要setSignValue 之后再获取, 不然使用 use {@link getCertificate}
         * @returns string | false string 为当前证书  false获取失败
         */
        this.getCertificateV2 = function () {
            if (_this._certificate) {
                return convertStringToBase64(_this._certificate);
            }
            return false;
        };
        /**
         * 获取csr 证书签名请求
         * @returns csr string
         */
        this.getCertSignRequest = function () {
            var certification = _this._getCertificatePem().certification;
            return convertStringToBase64(certification);
        };
        /**
         * 传参当前ts_sign 获取ticket时从可信lib 获取的数据
         * @param sign object base64转码之后的对象
         * @returns string | false false 标识base64解码失败 string 当前需要防护的数据
         */
        this.setSignValue = function (sign) {
            var _a, _b;
            var _c = sign || {}, ts_sign = _c.ts_sign, ticket = _c.ticket, client_cert = _c.client_cert;
            if (client_cert && _this._certType === 'header') {
                _this._certificate = client_cert;
                (_a = _this._cacheSDK) === null || _a === void 0 ? void 0 : _a.set(certificateCacheKey, client_cert);
            }
            // this._ts_sign = ts_sign;
            try {
                var sign_data = JSON.stringify(sign);
                _this._sign_data = sign_data;
                (_b = _this._cacheSDK) === null || _b === void 0 ? void 0 : _b.set("".concat(signDataCacheKey, "/").concat(_this._scene), sign_data);
                return ticket;
            }
            catch (error) {
                return false;
            }
        };
        /**
         * 传参当前ts_sign 获取ticket时从可信lib 获取的数据
         * @param sign string base64
         * @returns string | false false 标识base64解码失败 string 当前需要防护的数据
         */
        this.setSignValueV2 = function (sign) {
            var _a, _b;
            var sign_data = convertBase64ToString(sign);
            try {
                _this._sign_data = sign_data;
                var res = sign_data && JSON.stringify(sign_data);
                var _c = res || {}, ts_sign = _c.ts_sign, ticket = _c.ticket, client_cert = _c.client_cert;
                if (client_cert && _this._certType === 'header') {
                    _this._certificate = client_cert;
                    (_a = _this._cacheSDK) === null || _a === void 0 ? void 0 : _a.set(certificateCacheKey, client_cert);
                }
                (_b = _this._cacheSDK) === null || _b === void 0 ? void 0 : _b.set("".concat(signDataCacheKey, "/").concat(_this._scene), sign_data);
                // this._ts_sign = ts_sign;
                return ticket;
            }
            catch (error) {
                // console.log(error);
                return false;
            }
        };
        /**
         * sign request data
         * @param sign_data need sign data 如果不传则使用ts_sign内防护的ticket
         * @returns string base64编码的数据，数据内部包含ts_sign， req_content req_sign
         */
        this.sign = function (sign_data) {
            var _a, _b;
            var ts_sign_data = _this._sign_data;
            if (!ts_sign_data) {
                ts_sign_data = ((_a = _this._cacheSDK) === null || _a === void 0 ? void 0 : _a.get("".concat(signDataCacheKey, "/").concat(_this._scene))) || '';
            }
            try {
                var _c = JSON.parse(ts_sign_data || ''), ticket = _c.ticket, ts_sign = _c.ts_sign;
                if (!sign_data && !ticket) {
                    return '';
                }
                var sig_data = (_b = _this.cryptoSDK) === null || _b === void 0 ? void 0 : _b.sign(sign_data || ticket);
                var base64_sign_data = convertHexToBase64(sig_data || '');
                var sign_obj = {
                    ts_sign: ts_sign,
                    req_content: sign_data || ticket,
                    req_sign: base64_sign_data,
                };
                return convertStringToBase64(JSON.stringify(sign_obj));
            }
            catch (error) {
                return '';
            }
        };
        /**
         * sign request data
         * @param sign_data need sign data 如果不传则使用ts_sign内防护的ticket
         * @returns string base64编码的数据，数据内部包含ts_sign， req_content req_sign
         */
        this.signV2 = function (req_content, sign_data) {
            var _a, _b;
            var ts_sign_data = _this._sign_data;
            if (!ts_sign_data) {
                ts_sign_data = ((_a = _this._cacheSDK) === null || _a === void 0 ? void 0 : _a.get("".concat(signDataCacheKey, "/").concat(_this._scene))) || '';
            }
            try {
                var _c = JSON.parse(ts_sign_data || ''), ticket = _c.ticket, ts_sign = _c.ts_sign;
                if (!sign_data && !ticket) {
                    return '';
                }
                var sig_data = (_b = _this.cryptoSDK) === null || _b === void 0 ? void 0 : _b.sign(sign_data || ticket);
                var base64_sign_data = convertHexToBase64(sig_data || '');
                var sign_obj = {
                    ts_sign: ts_sign,
                    req_content: req_content || ticket,
                    req_sign: base64_sign_data,
                };
                return convertStringToBase64(JSON.stringify(sign_obj));
            }
            catch (error) {
                return '';
            }
        };
        /**
         * 获取当前ts_sign
         * @returns string 为ts_sign false 获取失败
         */
        this.getTsSign = function () {
            var _a;
            var ts_sign_data = _this._sign_data;
            if (!ts_sign_data) {
                ts_sign_data = ((_a = _this._cacheSDK) === null || _a === void 0 ? void 0 : _a.get("".concat(signDataCacheKey, "/").concat(_this._scene))) || '';
            }
            try {
                var ts_sign = JSON.parse(ts_sign_data || '').ts_sign;
                return ts_sign;
            }
            catch (error) {
                return false;
            }
        };
        /**
         * @deprecated use {@link getCertificate}
         * 获取当前公钥
         * @returns string
         */
        this.getPublicKey = function () {
            return { publicKey: _this._public_key || '' };
        };
        /**
         * 生成公私钥 + csr pem 方法
         * @returns object publicKey & privateKey & csr pem
         */
        this._getCertificatePem = function () {
            var _a, _b;
            if (single_certification && single_private_key && single_public_key) {
                return {
                    ec_privateKey: single_private_key || '',
                    ec_publicKey: single_public_key || '',
                    certification: single_certification || '',
                };
            }
            _this.cryptoSDK = new SecurityCrypto({ type: 'ECDSA' });
            var _c = ((_a = _this.cryptoSDK) === null || _a === void 0 ? void 0 : _a.getKeys()) || {}, publicKey = _c.publicKey, privateKey = _c.privateKey;
            var cert = (_b = _this.cryptoSDK) === null || _b === void 0 ? void 0 : _b.getCSR();
            single_certification = cert;
            single_private_key = privateKey;
            single_public_key = publicKey;
            return { ec_privateKey: privateKey || '', ec_publicKey: publicKey || '', certification: cert || '' };
        };
        /**
         * 刷新当前的密钥对+证书 多个业务共用SDK的话 尽量少使用当前refresh方法 可能会导致其他业务防护失效的问题
         * @param init 是否是初始化的时候刷新
         * @returns true or false
         */
        this.refresh = function (init) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ec_privateKey, ec_publicKey, certification, res, cert, error_1;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!init) {
                            requestCertPEMPromise = null;
                            single_certification = '';
                            single_private_key = '';
                            single_public_key = '';
                        }
                        _a = this._getCertificatePem(), ec_privateKey = _a.ec_privateKey, ec_publicKey = _a.ec_publicKey, certification = _a.certification;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        if (!requestCertPEMPromise) {
                            requestCertPEMPromise = this._request({
                                url: '/passport/ticket_guard/get_client_cert/',
                                method: 'POST',
                                data: {
                                    csr: convertStringToBase64(certification),
                                },
                            });
                        }
                        return [4 /*yield*/, requestCertPEMPromise];
                    case 2:
                        res = _e.sent();
                        cert = (res || {}).cert;
                        // console.log(cert);
                        if (cert) {
                            this._certificate = cert;
                            (_b = this._cacheSDK) === null || _b === void 0 ? void 0 : _b.set(certificateCacheKey, cert);
                        }
                        this._public_key = ec_publicKey;
                        this._private_key = ec_privateKey;
                        (_c = this._cacheSDK) === null || _c === void 0 ? void 0 : _c.set(publicCacheKey, this._public_key);
                        (_d = this._cacheSDK) === null || _d === void 0 ? void 0 : _d.set(privateCacheKey, this._private_key);
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _e.sent();
                        // console.log(error);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var aid = params.aid, scene = params.scene, cacheSDK = params.cacheSDK, _a = params.certType, certType = _a === void 0 ? 'header' : _a;
        this._cacheSDK = cacheSDK;
        this._certType = certType;
        this._scene = scene || 'token';
        this._request = createRequest({}, { aid: aid });
        this.checkCryptStatus = this._checkCryptKeys();
    }
    return CryptoSDK;
}());
export * from './utils';
export * from './utils/hooks';
export { processRequestConfig, processResponseConfig };
export default CryptoSDK;
